const style = {
  td_policyIpAddresses: {
    margin: 0,
  },
};

export default style;
